import React from 'react';
import { APP_VERSION } from './utilities/constants';
import './components/Footer/AppFooter.css';

const AppFooter = () => {
  const version = String(APP_VERSION || '');
  const versionLabel = version.toLowerCase().startsWith('v')
    ? version
    : `v${version}`;

  return (
    <div className="layout-footer modern-app-footer">
      <div className="footer-logo-container modern-app-footer__product">
        <span className="modern-app-footer__logo-wrap">
          <img
            src="assets/layout/images/supponor-logo-layered.png"
            alt="Supponor"
          />
        </span>

        <span className="modern-app-footer__product-text">
          <span className="app-name">Hub</span>
          <span className="modern-app-footer__version">
            {versionLabel}
          </span>
        </span>
      </div>

      <div className="modern-app-footer__right">
        <span className="copyright">
          Copyright © {new Date().getFullYear()} Supponor Oy
        </span>
      </div>
    </div>
  );
};

export default AppFooter;
